export const encryptHash = (screenId, verificationId, displayToken) => {
  const info = `${screenId}.${verificationId}`;
  const encoding = Buffer.from(displayToken).toString('base64'); // Encode the display token
  let result = Buffer.from(`${encoding}.${info}`).toString('base64'); // Add and encode to the other data

  if (result.indexOf('=') !== -1) {
    ([result] = result.split('='));
  }

  return result;
};

export const decryptHash = (hash) => {
  try {
    let result = Buffer.from(hash, 'base64').toString();
    result = result.split('.');
    result[0] = Buffer.from(result[0], 'base64').toString();
    return { screen_id: result[1], verification_id: result[2], display_token: result[0] };
  } catch (err) {
    console.error('Failed to decrypt hash:', err);
    return {};
  }
};
